import React, { useState } from "react";
import { ConfigReportComboApi } from "../../services/types";
import { CatalogReportCombo, TemplateInstanceReportCombo } from "../Template/types";

interface Props {
	templateItem: TemplateInstanceReportCombo;
	onBack: () => void;
	onUpdate: (templateItem: TemplateInstanceReportCombo) => void;
	catalogTemplate?: CatalogReportCombo;
}

export const CatalogTemplateEditReportComboComponent = (props: Props) => {
	const templateItem = props.templateItem;
	const [value, setValue] = useState(JSON.stringify(templateItem.data));

	const refresh = (newTemplate?: boolean) => {
		const newData = JSON.parse(value) as ConfigReportComboApi;
		const newTemplateItem = newTemplate
			? { ...templateItem, data: newData, template_id: undefined }
			: { ...templateItem, data: newData };
		props.onUpdate(newTemplateItem);
	};

	const save = () => {
		refresh();
		props.onBack();
	};

	const saveWithNew = () => {
		refresh(true);
		props.onBack();
	};

	const restore = () => {
		if (!props.catalogTemplate?.data) return;
		const newTemplateItem = { ...templateItem, data: props.catalogTemplate?.data };
		setValue(JSON.stringify(props.catalogTemplate?.data));
		props.onUpdate(newTemplateItem);
	};

	const isSameData = !props.catalogTemplate || JSON.stringify(props.catalogTemplate.data) === value;

	return (
		<div>
			<div className={`card border-primary mb-2`}>
				<div className="card-body">
					<h5 className="card-title">{templateItem.name}</h5>
					<p>Zmiana szablonu spowoduje zamianę jego na ręcznie zdefiniowany</p>
					<div className="form-floating mb-2">
						<textarea
							onChange={(e) => setValue(e.target.value)}
							className="form-control"
							placeholder="Leave a comment here"
							id="floatingTextarea2"
							style={{ height: 100 }}
							value={value}
						></textarea>
						<label htmlFor="floatingTextarea2">Config raportu</label>
					</div>
					<button className="btn btn-default" onClick={() => refresh(false)}>
						Odśwież
					</button>
					{!isSameData && (
						<>
							<p>Twój szablon różni się od szablonu zdefiniowanego, kliknij aby przywróć domyślny</p>

							<button className="btn btn-default" onClick={restore}>
								Przywróć szablon
							</button>
						</>
					)}
					<hr />
					<button className="btn btn-primary" onClick={save}>
						Zapisz
					</button>
					{` `}
					{templateItem.template_id && (
						<>
							<button className="btn btn-primary" onClick={saveWithNew}>
								Zapisz jako nowy
							</button>
							{` `}
						</>
					)}
					<button className="btn btn-default" onClick={props.onBack}>
						Anuluj
					</button>
				</div>
			</div>
		</div>
	);
};
